import { call, put, takeLatest,} from "redux-saga/effects";
import { push } from "connected-react-router";
import { api_put, PROYECT } from "services/api";
// Reset password
const INIT_RESET_PASSWORD = "INIT_RESET_PASSWORD";
const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";
const CLEAR_RESET_PASSWORD_RESPONSE = "CLEAR_RESET_PASSWORD_RESPONSE";

const INITIAL_STATE = {
  successMessage: "",
  errorMessage: "",
  error: false,
  isLoading: false,
  success: false,
};


const resetPasswordReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case INIT_RESET_PASSWORD:
      return {
        ...state,
        isLoading: true,
        error: false,
        successMessage: "",
        errorMessage: ""
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        successMessage: `Solicitud satisfactoria, revise su correo electrónico: ${ payload }`,
        success: true,
        error: false
      };
    case RESET_PASSWORD_ERROR:
      return {
        ...state,
        isLoading: false,
        error: true,
        success: false,
        errorMessage: payload,
      };
    case CLEAR_RESET_PASSWORD_RESPONSE:
      return {
        ...state,
        error: false,
        success: false,
        errorMessage: "",
        successMessage: ""
      };
    default:
      return state;
  }
};


function clearResponse() {
  return {
    type: CLEAR_RESET_PASSWORD_RESPONSE,
  };
}
function initResetPassword(body) {
  return {
    type: INIT_RESET_PASSWORD,
    body,
  };
}

function* resetPassword(action) {
  const { body } = action;

  const url = `${process.env.REACT_APP_URL}${PROYECT}/users/${body.username}/password/reset`;

  try {
    const response = yield call(api_put, url, body);
    yield put({
      type: RESET_PASSWORD_SUCCESS,
      payload: response
    });
    yield put(push("/auth/login"));
  } catch (error) {
    yield put({
      type: RESET_PASSWORD_ERROR,
      payload: error,
    });
  }
}

function* resetPasswordSaga() {
  yield takeLatest(INIT_RESET_PASSWORD, resetPassword);
}

export {
  // reducer
  resetPasswordReducer,
  // actions
  initResetPassword,
  clearResponse,
  //sagas
  resetPasswordSaga,
};
